import * as React from 'react';
import cn from 'classnames';

import { EngineRenderers } from '@websky/core/src/renderProps';
import { getDurationString } from '@websky/core/src/Results/utils';
import FlightCard from '@websky/core/src/FlightCard';
import TransferInfo from '@websky/core/src/TransferInfo';
import { useTheme } from '@websky/core/src/theme';

import Location from '../Location/Location';
import * as theme from './FlightInfoSegment.css';

export const FlightInfoSegment: EngineRenderers['renderFlightInfoSegment'] = props => {
	const { FlightInfo: css } = useTheme('FlightInfo');
	const {
		segment: { segment, transferDuration },
		onAircraftModalOpen,
		nextSegment
	} = props;

	return (
		<div key={segment.flightNumber} className={cn(css.segment, theme.segment)}>
			<div className={css.segment__info}>
				<div className={theme.locationsWrapper}>
					<Location
						type={'departure'}
						className={cn(css.segment__location, theme.location)}
						{...segment.departure}
					/>
					<Location
						type={'arrival'}
						className={cn(css.segment__location, theme.location)}
						{...segment.arrival}
					/>
				</div>

				<FlightCard
					onAircarftInfoClick={onAircraftModalOpen}
					className={cn(css.segment__flight, theme.flight)}
					airline={segment.operatingAirline}
					flightNumber={`${segment.marketingAirline?.iata}-${segment.flightNumber}`}
					duration={getDurationString(segment.duration)}
					aircraft={segment.aircraft}
					amenities={segment.flightInfo?.amenities}
					markers={segment.flightInfo?.markers}
					statistics={segment.flightInfo?.statistics}
				/>
			</div>

			{transferDuration && (
				<TransferInfo
					className={css.segment__transfer}
					segment={segment}
					nextSegment={nextSegment}
					transferDuration={transferDuration}
					showStops={true}
				/>
			)}
		</div>
	);
};

export default FlightInfoSegment;
